/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as API from "../../framework/API/api"
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { EditPageHeader } from '../../components/EditPageHeader';
import { useTranslation } from '../../locale/useTranslation';
import { PaymentsEditForm } from './PaymentsEditForm';
import moment from 'moment';
import { utility } from '../../framework/utility/utilityProvider';
import OttFilterTemplate from '../../framework/OTT/OttFilterTemplate';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import MyMultiSelect from '../../components/MyMultiSelect';
import { ProviderTabForm } from './ProviderTabForm';
import TooltipInfoCard from '../../components/TooltipInfoCard';
import ToastNotification from "../../components/ToastNotification";

const PaymentPlanEditForm = () => {

  const [currency, setCurrency] = useState([]);
  const [ottPeriod, setOttPeriod] = useState([]);
  const [ottProducts, setOttProducts] = useState([]);
  const [features, setFeatures] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [payments, setPayments] = useState([]);
  const [tabNumber, setTabNumber] = React.useState("1");
  const [showMediaFilter, setShowMediaFilter] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [providers, setProviders] = useState([]);
  const [dataItem, setDataItem] = useState({
    Description: "",
    OttPeriod: {},
    Product: {},
    ProductId: "",
    Currency: {},
    Amount: 0,
    deviceLimit: 1,
    Features: [],
    Features: [],
    Platforms: [],
    EnableFixedTrial: false,
    StartDate: "",
    EndDate: "",
    Archive: false
  });


  const navigate = useNavigate();
  const loc = useLocation();
  const { SID } = useParams();
  const lang = useTranslation();

  useEffect(() => {
    loadcombo();
    if (SID > 0) {
      loadEditData();
    }
  }, []);

  const loadcombo = async () => {
    let ottPeriod = await API.getDataLookup(ENTITYNAME.OttPeriod, { query: ["Archive", "=", false], sort: { Name: 1 } });
    setOttPeriod(ottPeriod.data);
    let currency = await API.getDataLookup(ENTITYNAME.Currency, { query: ["Archive", "=", false], sort: { Description: 1 } });
    setCurrency(currency.data);
    let product = await API.getDataLookup(ENTITYNAME.OttProduct, { query: ["Archive", "=", false], sort: { Title: 1 } });
    setOttProducts(product.data);
    let featuresRes = await API.getDataLookup(ENTITYNAME.PaymentPlanFeature, { query: ["Archive", "=", false], sort: { SID: 1 } });
    setFeatures(featuresRes.data);
    let platformRes = await API.getDataLookup(ENTITYNAME.Platform, { query: ["Archive", "=", false], sort: { SID: 1 } });
    setPlatforms(platformRes.data);
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const onChange = (e) => {
    if (e.target.name == 'EnableFixedTrial') {
      setDataItem({ ...dataItem, EnableFixedTrial: !dataItem.EnableFixedTrial });
    } else if (e.target.name == 'EnableReminder') {
      setDataItem({ ...dataItem, EnableReminder: !dataItem.EnableReminder });
    } else if (e.target.name == 'Archive') {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  };

  const loadEditData = async () => {
    let res = await API.getPaymentPlan({ SID: parseInt(SID) });
    console.log(res);

    if (res.success) {
      setDataItem({
        ...res.data,
        Platforms: res.data.Platforms?.length > 0 ? res.data.Platforms : [],
        Features: res.data.Features?.length > 0 ? res.data.Features : [],
        StartDate: res.data.FixedTrial.StartDate == 0 ? 'YYYY-MM-DD' : moment(new Date(res.data.FixedTrial.StartDate)).format('YYYY-MM-DD'),
        EndDate: res.data.FixedTrial.EndDate == 0 ? 'YYYY-MM-DD' : moment(new Date(res.data.FixedTrial.EndDate)).format('YYYY-MM-DD'),
        Description: res.data.Description,
        deviceLimit: res.data.deviceLimit ?? 1
      });
      setPayments(res.data.Payments ?? []);
      setProviderData(res.data.Providers ?? []);
      setFilterData(res.data.filterTemplate ?? {});
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  };

  const setProviderData = async (data) => {
    if (!data || data.length == 0) return;
    const idList = data.map((x) => x._id);
    let res = await API.getData(ENTITYNAME.OttProvider, { query: ["_id", "in", idList] });
    setProviders(res.data);
  }

  const isValid = () => {
    if (dataItem.Description == "" || dataItem.Description == {}) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
      return false;
    }
    if (!dataItem.OttPeriod || Object.keys(dataItem.OttPeriod).length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_period_error_message });
      return false;
    }
    if (!dataItem.Product || Object.keys(dataItem.Product).length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_product_error_message });
      return false;
    }

    if (!dataItem.Platforms || dataItem.Platforms.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_platform_type_error_msg });
      return false;
    }

    if (!dataItem.Currency || Object.keys(dataItem.Currency).length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_Currency_error_message });
      return false;
    }

    if (!(dataItem.Amount)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_amount_error_message });
      return false;
    }

    if (!(dataItem.deviceLimit) || dataItem.deviceLimit < 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.maximun_device_should_not_be_less_than_one });
      return false;
    }

    if (dataItem.EnableFixedTrial) {
      if (!utility.isValidDate(dataItem.StartDate)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_start_date_error_message });
        return false;
      }
      if (!utility.isValidDate(dataItem.EndDate)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_end_date_error_message });
        return false;
      }
    }
    if (payments.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_PaymentType_error_message });
      return false;
    }
    const appleSubscription = payments.some(x => x.Name === "AppleSubscription");
    if (appleSubscription && (!dataItem.ProductId || dataItem.ProductId === "")) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_product_id_required_for_applesubscription_in_payments_error_message });
      return false;
    }
    return true;
  }

  const onSaveData = async () => {
    if (!isValid()) return;
    const finalData = {
      _id: dataItem._id,
      SID: dataItem.SID ?? 0,
      Description: dataItem.Description,
      OttPeriod: dataItem.OttPeriod && Object.keys(dataItem.OttPeriod).length > 0 ? { _id: dataItem.OttPeriod?._id, SID: dataItem.OttPeriod?.SID, Days: dataItem.OttPeriod?.Days, Name: dataItem.OttPeriod?.Name, OttPeriodType: dataItem.OttPeriod?.OttPeriodType } : {},
      Currency: dataItem.Currency && Object.keys(dataItem.Currency).length > 0 ? { _id: dataItem.Currency._id, SID: dataItem.Currency.SID, Description: dataItem.Currency.Description } : {},
      Amount: parseFloat(dataItem.Amount),
      Product: {
        _id: dataItem.Product._id,
        SID: dataItem.Product.SID,
        Title: dataItem.Product.Title,
        Region: dataItem.Product.Region ? { _id: dataItem.Product.Region._id, Description: dataItem.Product.Region.Description } : {},
        Segments: dataItem.Product.Segments.map((x) => { return { _id: x._id, Description: x.Description } })
      },
      ProductId: dataItem.ProductId,
      EnableFixedTrial: dataItem.EnableFixedTrial ?? false,
      FixedTrial: {
        StartDate: dataItem.EnableFixedTrial ? new Date(dataItem.StartDate).getTime() : 0,
        EndDate: dataItem.EnableFixedTrial ? new Date(dataItem.EndDate).getTime() : 0
      },
      Payments: payments.length > 0 ? payments.map((x) => x?._id) : [],
      Providers: providers.length > 0 ? providers.map((x) => x?._id) : [],
      Features: dataItem.Features.length > 0 ? dataItem.Features : [],
      Platforms: dataItem.Platforms.map((x) => { return { _id: x._id, SID: x.SID, Description: x.Description } }),
      deviceLimit: parseInt(dataItem.deviceLimit) ?? 1,
      filterTemplate: filterData ?? {},
      Archive: dataItem.Archive ?? false
    }
    console.log(finalData);
    const res = await API.saveData(ENTITYNAME.PaymentPlan, finalData);
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Saved Successfully !!' });
      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PAYMENT_PLAN, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.PaymentPlan);
      onClose();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const toGetFilteredData = (data) => {
    setFilterData(data);
  }

  const onClose = () => {
    if (loc.state && loc.state.prevPath) {
      navigate(loc.state.prevPath)
    } else {
      navigate('/home/PaymentPlan');
    }
  }

  return (
    <>
      <div className='row m-1'>
        <div className='col-12'>
          <EditPageHeader title={`${lang.paymentPlan_sub_menu} -> ` + (dataItem.Description ? dataItem.Description : `${lang.new_title_editpageheader}`)} onSubmit={onSaveData} onCancel={onClose} />
          <div className='row mt-2'>
            <div className='col-12' style={{ borderRight: "ridge" }}>

              <div className='row form-group'>
                <div className="col-3">
                  <label htmlFor="">{lang.name_label} *</label>
                  <input name="Description" type="text" className="form-control form-control-sm" value={dataItem.Description} onChange={onChange} required />
                </div>
                <div className="col-3">
                  <label htmlFor="TabView">{lang.period_label} *</label>
                  <DropDownList
                    style={{ backgroundColor: "white" }}
                    data={ottPeriod}
                    name="OttPeriod"
                    textField="Name"
                    dataItemKey="_id"
                    value={dataItem.OttPeriod}
                    onChange={onChange}
                  />
                </div>

                <div className="col-3">
                  <label htmlFor="TabView">{lang.product_label} *</label>
                  <DropDownList
                    style={{
                      backgroundColor: "white",
                    }}
                    data={ottProducts}
                    name="Product"
                    textField="Title"
                    dataItemKey="_id"
                    value={dataItem.Product}
                    onChange={onChange}
                  />
                </div>
                <div className="col-3">
                  <label>{lang.product_id_label}</label><TooltipInfoCard message={lang.product_id_info_message} placement="left" />
                  <input type="text" className="form-control form-control-sm" name="ProductId" value={dataItem.ProductId} onChange={onChange} />
                </div>
              </div>
              <div className='row form-group'>
                <div className="col-3">
                  <label htmlFor="TabView">{lang.currency_label} *</label>
                  <DropDownList
                    style={{
                      backgroundColor: "white",
                    }}
                    data={currency}
                    name="Currency"
                    textField="Description"
                    dataItemKey="_id"
                    value={dataItem.Currency}
                    onChange={onChange}
                  />
                </div>
                <div className="col-3">
                  <label>{lang.amount_label} *</label>
                  <input type="number" className="form-control form-control-sm" name="Amount" value={dataItem.Amount} onChange={onChange} min={0} />
                </div>
                <div className="col-3">
                  <label>{lang.maximum_devices_label}</label>
                  <input type="number" className="form-control form-control-sm" name="deviceLimit" value={dataItem.deviceLimit} onChange={onChange} min={1} />
                </div>
                <div className="col-3">
                  <label>{lang.feature_label}</label>
                  <MyMultiSelect
                    style={{ backgroundColor: "white" }}
                    data={features}
                    name="Features"
                    textField="Description"
                    dataItemKey="SID"
                    value={dataItem.Features}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-6'>
                  <label>{lang.media_filter_label}</label><TooltipInfoCard message={lang.media_filter_info} />
                  <div className='d-flex'>
                    <input
                      name="EnableFilter"
                      type="text"
                      className="form-control form-control-sm"
                      value={filterData?.Template?.Name ?? ''}
                      onChange={onChange}
                      disabled={true}
                    />
                    <ActionButton style={{ height: "30px" }} btnColor={"success"} title={lang.select_button_tooltip} name={"..."} onClick={() => setShowMediaFilter(true)} />
                    <ActionButton style={{ height: "30px" }} btnColor={"danger"} title={lang.remove_filtter_button_tooltip} name={""} icon={"xmark"} onClick={() => setFilterData({})} />
                  </div>
                </div>
                <div className="col-6">
                  <label htmlFor="TabView">{lang.platform_label} *</label><br />
                  <MyMultiSelect
                    style={{ backgroundColor: "white" }}
                    data={platforms}
                    name="Platforms"
                    textField="Description"
                    dataItemKey="SID"
                    value={dataItem.Platforms}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className='col d-flex'>
                <div className="mt-2">
                  <input name="Archive" type="checkbox" value={dataItem.Archive} checked={dataItem.Archive} onClick={onChange} />
                  <label className='ml-1'>{lang.archive}</label>
                </div>
                <div className='mt-2 ml-5'>
                  <input name="EnableFixedTrial" type="checkbox" value={dataItem.EnableFixedTrial} checked={dataItem.EnableFixedTrial} onClick={onChange} />
                  <label className='ml-1'>{lang.enable_fixed_trial_label}</label>
                </div>
                {dataItem.EnableFixedTrial && <>
                  <div className='mt-2 ml-4'>
                    <label>{lang.start_date_label} *</label><br />
                    <input type="date" name="StartDate" value={dataItem.StartDate} onChange={onChange} max={dataItem.EndDate}
                      className="form-control form-control-sm" label={lang.start_date_label}
                    />
                  </div>
                  <div className='mt-2 ml-4'>
                    <label>{lang.end_Date_label} *</label><br />
                    <input type="date" name="EndDate" onChange={onChange} value={dataItem.EndDate} min={dataItem.StartDate}
                      className="form-control form-control-sm" label={lang.end_Date_label}
                    />
                  </div>
                </>}
              </div>
            </div>
          </div>
        </div>

        <div className='col-12'>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabNumber}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange} aria-label="tabs example">
                  <Tab label={lang.payments_label} value="1" />
                  <Tab label={lang.provider_label} value="2" />
                </TabList>
              </Box>
              <TabPanel value={"1"}>
                <PaymentsEditForm data={payments} setPaymentsData={setPayments} />
              </TabPanel>
              <TabPanel value={"2"}>
                <ProviderTabForm data={providers} setProviderData={setProviders} />
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </div>
      {showMediaFilter && (
        <OttFilterTemplate
          toGetFilterDataItem={toGetFilteredData}
          title={lang.media_filter_dialog_header}
          saveButtonName={lang.add_button_text}
          showDefaultButton={false}
          filterDataItem={filterData}
          setTemplate={setDataItem}
          onClose={setShowMediaFilter}
        />
      )}
    </>
  )
}

export default PaymentPlanEditForm